import SelectionOption from '../../base/option/SelectionOption';
import Lang from '../../global/Lang';

enum ScanCronType {
  DAILY = 'DAILY',
  EVERY_6_HOURS = 'EVERY_6_HOURS',
  EVERY_12_HOURS = 'EVERY_12_HOURS',
  WEEKLY = 'WEEKLY',
}

const ScanCronTypes: ScanCronType[] = Object.keys(ScanCronType).map(
  (k) => k as ScanCronType
);

const ScanCronTypeMap: { [key in keyof typeof ScanCronType]: SelectionOption } = {
  DAILY: {
    name: Lang.t('preference.dailyAtMidnight'),
    value: '0 0 * * *',
  },
  EVERY_6_HOURS: {
    name: Lang.t('preference.every6Hours'),
    value: '0 */6 * * *',
  },
  EVERY_12_HOURS: {
    name: Lang.t('preference.every12Hours'),
    value: '0 */12 * * *',
  },
  WEEKLY: {
    name: Lang.t('preference.weeklyOnSunday'),
    value: '0 0 * * 0',
  },
};

const ScanCronTypeList: SelectionOption[] = [];
ScanCronTypes.forEach((type: ScanCronType) => {
  ScanCronTypeList.push(ScanCronTypeMap[type]);
});

const ScanCronTypeValueList: string[] = [];
ScanCronTypes.forEach((type: ScanCronType) => {
  ScanCronTypeValueList.push(ScanCronTypeMap[type].value);
});

export {
  ScanCronType,
  ScanCronTypeMap,
  ScanCronTypeList,
  ScanCronTypeValueList,
};